import { TextFieldComponent } from '@vivli/shared/components';
import { CSSProperties, useState } from 'react';
import { useRorHelpers, useRorSearchHook } from '@vivli/features/organizations/infrastructure/hook';
import { useModalApiContext } from '@vivli/core/infrastructure/context';
import { IRorResponseItem } from '@vivli/features/organizations/infrastructure/interface';
import { Color } from '@vivli/shared/theme';
import { ButtonView, LoadIndicatorView } from '@vivli/shared/views';

const institutionContainerStyle: CSSProperties = {
    width: '100%',
    height: '250px',
    backgroundColor: Color.WHITE_TINTED,
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    padding: '30px',
};

const institutionDivStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
    gap: '10px',
};
export const EnterInstitutionComponent = ({ onCancel, index, handleUpdateRow, field }) => {
    const rorSearch = useRorSearchHook();
    const { getRorName } = useRorHelpers();
    const modalService = useModalApiContext();
    const [suggestedOrganization, setSuggestedOrganization] = useState<string>('');
    const [isLoading, setIsLoading] = useState(false);
    const [institutionNameField, setInstitutionNameField] = useState('');

    const handleError = (e, toast?: string) => {
        setIsLoading(false);
        const message = toast ? toast + e : e;
        modalService.error(message);
    };

    const handleResult = (selections: string, matches: IRorResponseItem[]) => {
        const selected = matches.find((item) => selections == item.id);
        const rorName = getRorName(selected);
        selected && setInstitutionNameField(rorName);
        setIsLoading(false);
    };

    const handleRequestedRorSearch = () => {
        setIsLoading(true);
        rorSearch({
            searchTerm: suggestedOrganization,
            onError: handleError,
            onConfirm: handleResult,
            setIsLoading: setIsLoading,
        });
    };

    return isLoading ? (
        <div style={{ ...institutionContainerStyle, justifyContent: 'center', alignItems: 'center' }}>
            <LoadIndicatorView />
        </div>
    ) : (
        <div style={institutionContainerStyle}>
            <div style={institutionDivStyle}>
                <div>Search ROR for name of institution or enter it directly</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div style={{ width: '60%' }}>
                        <TextFieldComponent value={suggestedOrganization} onChange={(e) => setSuggestedOrganization(e.target.value)} />
                    </div>

                    <ButtonView onClick={handleRequestedRorSearch} disabled={suggestedOrganization.length === 0}>
                        Search ROR
                    </ButtonView>
                </div>
            </div>

            <div style={institutionDivStyle}>
                The following institution name will be used
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div style={{ width: '60%' }}>
                        <TextFieldComponent
                            value={institutionNameField}
                            onChange={(e) => setInstitutionNameField(e.target.value)}
                            innerStyle={{ width: '94%' }}
                        />
                    </div>
                    <ButtonView
                        onClick={() => {
                            setIsLoading(true);
                            onCancel();
                            handleUpdateRow(index, field, institutionNameField);
                            setIsLoading(false);
                        }}
                    >
                        Save Name
                    </ButtonView>
                </div>
            </div>
        </div>
    );
};
